import React from 'react';

import Message from '../message';

type THomeProps = {
  messages: Array<IMessage> | undefined;
  refetch: () => void;
};

const MessageList = ({messages, refetch}: THomeProps) => {
  return (
    <>
      {React.Children.toArray(
        messages?.map(item => (
          <>
            <Message refetch={refetch} message={item} />
          </>
        )),
      )}
    </>
  );
};

export default MessageList;
